import { isObject, merge, reduce, set, camelCase } from "lodash";

export const flattenKeys = <TValue = unknown>(obj: object, path: string[] = []): Record<string, TValue> => {
	if (isObject(obj) === false) {
		return { [path.join(".")]: obj };
	}

	return reduce(obj, (acc, next, key) => merge(acc, flattenKeys(next, [...path, key])), {});
};

export const expandKeys = (obj: object) => {
	const entries = Object.entries(obj);

	return entries.reduce((acc, [key, val]) => set(acc, key, val), {});
};

export const camelCaseKeys = (obj: object): object => {
	const transformValue = (valueToTransform: unknown) => {
		if (Array.isArray(valueToTransform)) {
			return valueToTransform.map((item) => (isObject(item) ? camelCaseKeys(item) : item));
		}

		if (isObject(valueToTransform)) {
			return camelCaseKeys(valueToTransform);
		}

		return valueToTransform;
	};

	const entries = Object.entries(obj);

	return entries.reduce((acc, [key, val]) => {
		return {
			...acc,
			[camelCase(key)]: transformValue(val),
		};
	}, {});
};
